import { render, staticRenderFns } from "./Company-registration.vue?vue&type=template&id=4218ecda&scoped=true&"
import script from "./Company-registration.vue?vue&type=script&lang=js&"
export * from "./Company-registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4218ecda",
  null
  
)

export default component.exports